import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../../App';
import { HeartHandshake, X, ArrowRight } from 'lucide-react';

const DISMISS_KEY = 'care_profile_banner_dismissed_at';
const DISMISS_DAYS = 7;

const CareProfileBanner = () => {
  const navigate = useNavigate();
  const [state, setState] = useState('hidden'); // hidden | new | resume

  useEffect(() => {
    const dismissedAt = localStorage.getItem(DISMISS_KEY);
    if (dismissedAt && Date.now() - Number(dismissedAt) < DISMISS_DAYS * 24 * 3600 * 1000) return;
    axios.get(`${API}/assessments/care_profile/progress`)
      .then(res => {
        if (res.data.has_results) return;
        setState(res.data.progress ? 'resume' : 'new');
      })
      .catch(() => {});
  }, []);

  if (state === 'hidden') return null;

  return (
    <button
      onClick={() => navigate('/care-profile')}
      className="w-full text-left rounded-2xl p-4 bg-gradient-to-r from-cyan-600 to-teal-600 text-white relative shadow-md hover:shadow-lg transition-shadow"
      data-testid="care-profile-banner"
    >
      <span
        onClick={(e) => { e.stopPropagation(); localStorage.setItem(DISMISS_KEY, String(Date.now())); setState('hidden'); }}
        className="absolute top-2.5 right-2.5 p-1 rounded-full hover:bg-white/20"
        data-testid="care-profile-banner-dismiss"
        role="button"
      >
        <X className="w-3.5 h-3.5" />
      </span>
      <div className="flex items-center gap-3 pr-6">
        <HeartHandshake className="w-8 h-8 shrink-0" />
        <div className="flex-1">
          <p className="font-bold text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {state === 'resume' ? 'Finish your Care Profile™' : 'Discover your Care Profile™'}
          </p>
          <p className="text-xs opacity-90 mt-0.5">
            {state === 'resume'
              ? 'You\'re part-way there — pick up right where you left off.'
              : '8–10 minutes to show your squad exactly how to support you.'}
          </p>
        </div>
        <ArrowRight className="w-4 h-4 shrink-0" />
      </div>
    </button>
  );
};

export default CareProfileBanner;
